<template>
    <v-bottom-navigation v-model="bottomNav" fixed grow class="mobile-bottom-navigation" app>
        <v-btn class="px-1" @click="clearHomeContent">
            <icon-svg icon="logo" :color="$vuetify.theme.dark ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.dark.primary" :size="36"></icon-svg>
        </v-btn>
        <v-btn class="px-1" to="/explore/">
            <v-icon large :color="$vuetify.theme.dark ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.dark.primary">mdi-magnify</v-icon>
        </v-btn>
        <v-btn class="px-1" to="/create/post/">
            <v-icon large :color="$vuetify.theme.dark ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.dark.primary">mdi-border-none</v-icon>
        </v-btn>
        <!-- <v-badge overlap color="red" content="2" offset-y="18" offset-x="22" class="bottom-button">
            <v-btn class="px-1">
                <v-icon large :color="$vuetify.theme.dark ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.dark.primary">mdi-heart-outline</v-icon>
            </v-btn>
        </v-badge> -->
        
        <v-btn  v-if="user && user.name" :to="`/${user.username}`">
            <v-avatar color="blue white--text" small size="40">
                <img v-if="user.avatar_url" :src="user.avatar_url" :alt="user.name">
                <span class="title" v-else>{{user.name[0]}}</span>
            </v-avatar>
        </v-btn>
        <v-btn :loading="userLoading" v-else class="px-1" to="/account/login/">
            <v-icon large :color="$vuetify.theme.dark ? $vuetify.theme.themes.light.primary : $vuetify.theme.themes.dark.primary">mdi-account-outline</v-icon>
        </v-btn>
        
    </v-bottom-navigation>
</template>
<style lang="scss">
.bottom-button {
    display: flex;
    width: 100%;
    min-width: 60px;
    flex: 0 1 auto;
    max-width: 168px;

    .v-badge__wrapper {
        max-width: 60px;
        margin: auto;
        right: 0;
    }
}
</style>
<script>
import {
    GET_POST_LIST
} from "@/store/actions.type"

import {
    CLEAR_POST_LIST
} from "@/store/mutations.type"

export default {
    data: () => ({
        bottomNav: true
    }),

    methods: {
        clearHomeContent() {
            window.scroll(0, 0)
            this.$store.commit(CLEAR_POST_LIST) // resting all page variables and post
            this.$store.dispatch(GET_POST_LIST)
            this.$router.push('/', () => {})
        }
    }
}
</script>